<template>
  <div
    class="container min-body-height"
    :class="UI.isMobile ? '' : 'padding-top'"
  >
    <div
      class="flex align-center justify-between"
      :class="UI.isMobile ? 'flex-direction' : ''"
    >
      <h1>文件下载</h1>
      <el-form
        :inline="!UI.isMobile"
        :label-position="UI.isMobile ? 'top' : 'right'"
        size="mini"
        :model="filterForm"
      >
        <el-form-item label="文件名">
          <el-input
            clearable
            v-model="filterForm.title"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="
              page = 1;
              flushData();
            "
          >
            查询
          </el-button>
          <el-button
            @click="
              filterForm = { page: 1, page_size: 10 };
              flushData();
            "
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="full-width margin-bottom bg-grey" style="height: 1px;"></div>

    <el-table
      class="margin-top"
      :data="tableData"
      style="width: 100%"
      header-row-class-name="bg-default"
      :row-class-name="tableRowClassName"
    >
      <el-table-column prop="title" label="文件名"></el-table-column>
      <el-table-column prop="desc" label="描述"></el-table-column>

      <el-table-column prop="state" label="下载">
        <template slot-scope="scope">
          <a :href="scope.row.url" target="_blank">点击下载</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getFilesList } from '@/servers/filesDownload.js';
import { mapState } from 'vuex';

import { wxShareMixins } from '@/mixins/wx_share.js';

export default {
  mixins: [wxShareMixins],
  data() {
    return {
      filterForm: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      tableData: [],
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.flushData();
  },

  methods: {
    flushData: function() {
      let that = this;
      this.page = 1;
      getFilesList(this.filterForm, function(res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'bg-gray';
      } else {
        return 'bg-white';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/filesDownload/index.vue